var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXyo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4 2 16.124l7 12.123h14l.231-.394 6.77-11.724-7-12.13H9zm1.334 1.606h10.37l-6.818 2.156c.124.203.213.425.263.658l7.846-2.475 1.567 7.614c.23-.067.466-.102.705-.104l-1.316-6.302 4.982 8.62H26.93a3.168 3.168 0 0 1 .001.705h1.004l-5.143 8.91 1.437-6.594a2.704 2.704 0 0 1-.693-.107l-1.694 7.76-7.678-2.57c-.041.23-.117.451-.224.658l6.248 2.094h-9.852l.526-.9a2.653 2.653 0 0 1-.62-.335l-.518.892-4.91-8.505L9.68 22.08c.133-.194.292-.371.473-.525l-6.127-5.41 6.354-5.64a2.298 2.298 0 0 1-.42-.567L4.77 14.54 9.722 5.96l.732 1.273c.179-.158.38-.287.6-.383l-.72-1.244zm3.715 4.1a2.126 2.126 0 0 1-.354.61l8.155 4.71c.098-.214.223-.415.374-.597l-8.175-4.724zm-2.632 1.382v9.91c.108-.015.216-.022.325-.022a2.26 2.26 0 0 1 .38.028v-9.866a1.456 1.456 0 0 1-.17 0c-.18 0-.36-.02-.535-.061v.012zm10.436 6.134-8.166 4.71c.147.187.266.395.353.616l8.186-4.735a2.59 2.59 0 0 1-.372-.596v.005z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.959 6.664a2.244 2.244 0 1 0-.017 4.488 2.244 2.244 0 0 0 .016-4.488zm-.001.705a1.54 1.54 0 1 1-1.425.947 1.533 1.533 0 0 1 1.424-.948v-.001z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.744 20.976a2.463 2.463 0 1 0-.008 4.926 2.463 2.463 0 0 0 .008-4.926zm0 .698a1.763 1.763 0 1 1-.67.133 1.76 1.76 0 0 1 .674-.133h-.004z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.287 13.453a2.67 2.67 0 1 0 1.883.784c-.5-.5-1.179-.782-1.886-.784h.003zm0 .705a1.966 1.966 0 1 1-1.817 1.212 1.956 1.956 0 0 1 1.817-1.212z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXyo);
export default __webpack_public_path__ + "static/media/XYO.59b17b72787ddce6a2e9093075c85082.svg";
export { ForwardRef as ReactComponent };